import { getRequest, postRequest, putRequest, deleteRequest } from './api'

/**
 * Fetch all roles
 */
export async function listRoles() {
  return getRequest('roles')
}

/**
 * Fetch a single role by ID
 */
export async function fetchRole(id) {
  return getRequest(`roles/${id}`)
}

/**
 * Create a new role
 * @param {Object} data - Role data { name, description }
 */
export async function createRole(data) {
  return postRequest('roles', { values: data })
}

/**
 * Update an existing role (PUT)
 * @param {number} id - Role ID
 * @param {Object} data - Updated role data
 */
export async function updateRole(id, data) {
  return putRequest(`roles/${id}`, { values: data })
}

/**
 * Delete a role
 * @param {number} id - Role ID
 */
export async function deleteRole(id) {
  return deleteRequest(`roles/${id}`)
}

/**
 * Get permissions assigned to a role
 * @param {number} roleId - Role ID
 */
export async function fetchRolePermissions(roleId) {
  return getRequest(`roles/${roleId}/permissions`)
}

/**
 * Assign a permission to a role
 * @param {number} roleId - Role ID
 * @param {Object} data - Permission assignment data { permissionId, isDenied }
 */
export async function assignPermissionToRole(roleId, data) {
  return postRequest(`roles/${roleId}/permissions`, { values: data })
}

/**
 * Remove a permission from a role
 * @param {number} roleId - Role ID
 * @param {number} permissionId - Permission ID
 */
export async function removePermissionFromRole(roleId, permissionId) {
  return deleteRequest(`roles/${roleId}/permissions/${permissionId}`)
}

// ──── User-Role Management ────

/**
 * Get roles assigned to a user
 * @param {number} userId - User ID
 */
export async function fetchUserRoles(userId) {
  return getRequest(`roles/user-roles/${userId}`)
}

/**
 * Assign a role to a user
 * @param {Object} data - { userId, roleId }
 */
export async function assignRoleToUser(data) {
  return postRequest('roles/user-roles', { values: data })
}

/**
 * Remove a role from a user
 * @param {number} userId - User ID
 * @param {number} roleId - Role ID
 */
export async function removeRoleFromUser(userId, roleId) {
  return deleteRequest(`roles/user-roles/${userId}/${roleId}`)
}
